<section class="grid grid-cols-1 gap-y-10 px-4 py-20 sm:px-5 lg:grid-cols-24 lg:px-0">
  <div class="col-span-1 lg:col-span-6 lg:col-start-3">
    <h2 class="text-center text-4xl font-extrabold leading-tight text-gray-900 lg:text-left">
      {{ sectionTitle }}
    </h2>
    <p class="mx-auto mt-5 max-w-xl text-center text-lg font-normal leading-relaxed text-gray-500 sm:text-xl lg:mx-0 lg:text-left">
      {{ sectionDescription }}
    </p>
    @if (ctaLabel && ctaRoute) {
      <a
        [routerLink]="ctaRoute"
        class="mt-5 inline-flex items-center justify-center gap-1 text-lg font-medium leading-none text-blue-700 lg:justify-start">
        {{ ctaLabel }}
      </a>
    }
  </div>

  <div class="col-span-1 mt-2 grid lg:col-span-12 lg:col-start-11 lg:grid-cols-2 lg:gap-x-15 lg:gap-y-10">
    @for (item of items; track item.title) {
      <div class="mb-6 mt-5 lg:mb-0 lg:mt-0">
        <div class="flex flex-col items-center lg:items-start">
          <div class="mb-3 flex h-12 w-12 items-center justify-center rounded-md bg-blue-100 lg:mb-5">
            @switch (item.icon) {
              @case ('search') {
                <svg class="h-8 w-8 text-blue-800" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                  <path fill-rule="evenodd" d="M11.293 3.293a1 1 0 0 1 1.414 0l6 6 2 2a1 1 0 0 1-1.414 1.414L19 12.414V19a2 2 0 0 1-2 2h-3a1 1 0 0 1-1-1v-3h-2v3a1 1 0 0 1-1 1H7a2 2 0 0 1-2-2v-6.586l-.293.293a1 1 0 0 1-1.414-1.414l2-2 6-6Z" clip-rule="evenodd"/>
                </svg>
              }
              @case ('details') {
                <svg class="h-8 w-8 text-blue-800" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                  <path fill-rule="evenodd" d="M20.337 3.664c.213.212.354.486.404.782.294 1.711.657 5.195-.906 6.76-1.77 1.768-8.485 5.517-10.611 6.683a.987.987 0 0 1-1.176-.173l-.882-.88-.877-.884a.988.988 0 0 1-.173-1.177c1.165-2.126 4.913-8.841 6.682-10.611 1.562-1.563 5.046-1.198 6.757-.904.296.05.57.191.782.404ZM5.407 7.576l4-.341-2.69 4.48-2.857-.334a.996.996 0 0 1-.565-1.694l2.112-2.111Zm11.357 7.02-.34 4-2.111 2.113a.996.996 0 0 1-1.69-.565l-.422-2.807 4.563-2.74Zm.84-6.21a1.99 1.99 0 1 1-3.98 0 1.99 1.99 0 0 1 3.98 0Z" clip-rule="evenodd"/>
                </svg>
              }
              @case ('simulate') {
                <svg class="h-8 w-8 text-blue-800" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 15v4m6-6v6m6-4v4m6-6v6M3 11l6-5 6 5 5.5-5.5"/>
                </svg>
              }
              @case ('notifications') {
                <svg class="h-8 w-8 text-blue-800" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17.133 12.632v-1.8a5.406 5.406 0 0 0-4.154-5.262.955.955 0 0 0 .021-.106V3.1a1 1 0 0 0-2 0v2.364a.955.955 0 0 0 .021.106 5.406 5.406 0 0 0-4.154 5.262v1.8C6.867 15.018 5 15.614 5 16.807 5 17.4 5 18 5.538 18h12.924C19 18 19 17.4 19 16.807c0-1.193-1.867-1.789-1.867-4.175ZM8.823 19a3.453 3.453 0 0 0 6.354 0H8.823Z"/>
                </svg>
              }
            }
          </div>
        </div>
        <p class="text-center text-xl font-bold text-gray-900 lg:text-left">
          {{ item.title }}
        </p>
        <p class="mt-1 text-center text-base font-normal leading-normal text-gray-500 lg:text-left">
          {{ item.description }}
        </p>
      </div>
    }
  </div>
</section>
